import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

export default <FunctionalComponentOptions>{
    functional: true,

    props: {
        icon: {
            type: String,
            default: undefined
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'button', {
                class: 'wok--header__action',
                attrs: { role: 'button', ...ctx.data.attrs },
                on: ctx.listeners
            }, [
                h('i', { class: 'wok--header__action-icon' }, [
                    h(ctx.props.icon)
                ])
            ]
        )
    }
}